(function () {
  "use strict";
 
  var SUFFIX = " - ARC Iberico Imports";
 
  function cleanTitle(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function buildAlt(title) {
    var cleanedTitle = cleanTitle(title);
    return cleanedTitle ? cleanedTitle + SUFFIX : "";
  }
 

  function hasNoAlt(img) {
    var current = img.getAttribute("alt");
    return current === null || cleanTitle(current) === "";
  }
 
  function applyFallbackAlt(images, alt) {
    if (!alt) return;
 
    images.forEach(function (img) {
      if (hasNoAlt(img)) {
        img.setAttribute("alt", alt);
      }
    });
  }

  function updateCollectionGridAlts() {
    var items = document.querySelectorAll("[data-product-item]");
 
    items.forEach(function (item) {
      var titleLink = item.querySelector(".productitem--title a");
      if (!titleLink) return;
 
      var alt = buildAlt(titleLink.textContent);
      if (!alt) return;
 
      var images = item.querySelectorAll(
        ".productitem--image img, .productitem--image noscript img"
      );
 
      applyFallbackAlt(Array.prototype.slice.call(images), alt);
    });
  }
 
  function updateProductPageAlts() {
    var titleEl = document.querySelector(".product-title");
    if (!titleEl) return;
 
    var alt = buildAlt(titleEl.textContent);
    if (!alt) return;
 
    var gallery = document.querySelector(".product-gallery");
    if (!gallery) return;
 
    var images = gallery.querySelectorAll(
      "img, noscript img, .product-gallery--media-thumbnail-img"
    );
 
    applyFallbackAlt(Array.prototype.slice.call(images), alt);
  }

  function observeDynamicChanges() {
    var observer = new MutationObserver(function () {
      updateCollectionGridAlts();
      updateProductPageAlts();
    });
 
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
 
  function init() {
    updateCollectionGridAlts();
    updateProductPageAlts();
    observeDynamicChanges();
  }
 
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();